import React, {useEffect} from 'react';

import {KpiSinglePeriodChartWidgetConfigProps} from '../types';
import ResourcesProvider from '../../common/ResourcesProvider';
import KpiSinglePeriodChartWidgetConfigContent from './KpiSinglePeriodChartWidgetConfigContent';
import '../../aggregatedchart/config/KpiAggregatedChartWidgetConfig.scss';
import {isKpiWidgetItemValid, updatedKpiItem, validateKpiWidgetTimeConfig} from '../../common/kpiUtils';

const KpiSinglePeriodChartWidgetConfig = ({
	config,
	context,
	onChangeConfig,
	setApplyButtonDisabled
}: KpiSinglePeriodChartWidgetConfigProps) => {
	const {
		items,
		periodTimeframe,
		periodType,
		workingShiftEnabled,
		workingShiftDays,
		workingShiftTimeFrom,
		workingShiftTimeTo
	} = config.settings;
	useEffect(() => {
		const valid1 = items.every(isKpiWidgetItemValid);
		const valid2 = validateKpiWidgetTimeConfig(
			periodTimeframe,
			periodType,
			workingShiftEnabled,
			workingShiftDays,
			workingShiftTimeFrom,
			workingShiftTimeTo
		);
		setApplyButtonDisabled(!valid1 || !valid2);
	}, [
		items,
		periodTimeframe,
		periodType,
		workingShiftEnabled,
		workingShiftDays,
		workingShiftTimeFrom,
		workingShiftTimeTo,
		setApplyButtonDisabled
	]);
	return (
		<ResourcesProvider
			assetGroup={context.type === 'assetGroup' ? context.assetGroup : undefined}
			onAssetSelect={(asset, index) => {
				const newItems = updatedKpiItem(config.settings.items, index, {
					assetUrn: asset.urn,
					kpiName: undefined
				});
				onChangeConfig({...config, settings: {...config.settings, items: newItems}});
			}}
			onKpiNameSelect={(kpiName, index) => {
				const newItems = updatedKpiItem(config.settings.items, index, {
					kpiName
				});
				onChangeConfig({...config, settings: {...config.settings, items: newItems}});
			}}>
			{(setAssetSelecting, setKpiNameSelecting) => (
				<KpiSinglePeriodChartWidgetConfigContent
					context={context}
					config={config}
					onChangeConfig={onChangeConfig}
					setSelectingAsset={setAssetSelecting}
					setSelectingKpi={setKpiNameSelecting}
				/>
			)}
		</ResourcesProvider>
	);
};

export default KpiSinglePeriodChartWidgetConfig;
